// extracted by mini-css-extract-plugin
export default {"wrapper":"request_wrapper__LMkBg","controls":"request_controls__cRt0T","opacity-transition":"request_opacity-transition__5C28c"};